import React, { useState } from "react";
import moment from "jalali-moment";

const ProviderMessageCard = ({ notif }) => {
  return (
    <>
      <div className="panel-card flex flex-col mb-4">
        {/* <span className="show-label mb-2">
          شماره پیام: <span className="show-value">12345</span>
        </span> */}
        <span className="show-label  mb-2">
          تاریخ ارسال :{" "}
          <span className="show-value">
            {moment(notif.created_at, "YYYY/MM/DD")
              .locale("fa")
              .format("YYYY/MM/DD")}
          </span>
          {/* <span className="show-value">1401/12/11</span> */}
        </span>
        <span className="show-label  mb-1">
          ارسال کننده:
          <span className="show-value">
            {notif.sender.username}
            {/* <span className="show-value">مهدی ضیایی</span> */}
          </span>
        </span>
        <span className="show-label mb-1">
          موضوع پیام:
          <span className="show-value">{notif.title}</span>
          {/* <span className="show-value">خوش آمدگویی</span> */}
        </span>
        <span className="show-label mb-1">
          شرح پیام:
          <span className="show-value">{notif.description}</span>
          {/* <span className="show-value">به سامانه زرسان خوش آمدید</span> */}
        </span>
        {/* <span className="show-label mb-1">
          ارسال کننده:
          <span className="show-value">ادمین</span>
        </span> */}
      </div>
    </>
  );
};

export default ProviderMessageCard;
